'use strict';

wbApp.factory('activitySvc', ['$q', '$resource', 'repositorySvc',
    function ($q, $resource, repositorySvc) {
        var Activity = $resource('/Api/Activities/:id', {}, {
            'getAllBySemesterID': { method: 'GET', isArray: true, url: '/Api/Activities/GetAllBySemesterID' },
            'getByActivityID': { method: 'GET', url: '/Api/Activities/Get' },
            'getSummary': { method: 'GET', isArray: true, url: '/Api/Activities/GetSummary' },
            'getAllOpenForRegistration': { method: 'GET', isArray: true, url: '/Api/Activities/GetAllOpenForRegistration' },
            'insert': { method: 'POST', url: '/Api/Activities/Insert' },
            'update': { method: 'POST', url: '/Api/Activities/Update' },
            'delete': { method: 'POST', url: '/Api/Activities/Delete' },
            'registerActivityInterest': { method: 'POST', url: '/Api/Activities/registerActivityInterest' },
            'getPhotoAlbum': { method: 'GET', isArray: true, url: '/Api/Activities/getPhotoAlbum' },
            'getInfoByRange': { method: 'GET', isArray: true, url: '/restapi/activities/info/range' },
        });

        var bySemesterID;
        var lastSemesterID;

        var lastActivityByActivityID;
        var lastActivityID;

        function getByActivityID(activityID, refresh) {
            if (!lastActivityByActivityID || lastActivityID !== activityID || !!refresh) {
                lastActivityID = activityID;
                lastActivityByActivityID = repositorySvc.customGet('getByActivityID', Activity, {
                    activityID: activityID
                });
            }

            return lastActivityByActivityID;
        }
        
        function getInfoByRange(fromDate, toDate) {
            return repositorySvc.customGet('getInfoByRange', Activity, 
                {
                    fromDate: fromDate,
                    toDate: toDate,
                    expanded: 'Semester'
                });
        }

        function getAllBySemesterIDAsync(semesterID, reload) {
            if (!bySemesterID || lastSemesterID !== semesterID || reload) {
                bySemesterID = repositorySvc.customGet('getAllBySemesterID', Activity, { semesterID: semesterID });
                lastSemesterID = semesterID;
            }

            return bySemesterID;
        }

        function getSummary() {
            return repositorySvc.customGet('getSummary', Activity);
        }

        function getBySemesterIDAndActivityID(semesterID, activityID) {
            return $q(function (resolve, reject) {
                var activities = getAllBySemesterIDAsync(semesterID, false);
                activities.$promise.then(function () {
                    var activity = _.find(activities, { activityID: activityID });
                    if (!activity) {
                        reject("No activity with ID: " + activityID);
                    } else {
                        resolve(activity);
                    }
                }, function (errorResult) {
                    reject(errorResult);
                });
            });
        }

        function getPhotoAlbum(activityID, studentID) {
            return repositorySvc.customGet('getPhotoAlbum', Activity, { activityID: activityID, studentID: studentID });
        }

        function getAllOpenForRegistration() {
            return repositorySvc.customGet('getAllOpenForRegistration', Activity, { });
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                Activity,           // $resource
                bySemesterID,       // collection
                data,               // entity
                successCallback,
                errorCallback,
                'activityID');
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                Activity,           // $resource
                bySemesterID,       // collection
                data,               // entity
                successCallback,
                errorCallback,
                'activityID');
        }

        function remove(data, errorCallback) {
            return repositorySvc.remove(
                Activity,           // $resource
                bySemesterID,       // collection
                data,               // entity
                null,               // successCallback
                errorCallback,
                null,
                'activityID');
        }

        function registerActivityInterest(semestedID, successCallback, errorCallback) {
            Activity.registerActivityInterest({ semesterID: semestedID },
                successCallback,
                error);

            function error(errorResult) {
                repositorySvc.defaultErrorHandler(errorResult, errorCallback);
            }
        }

        return {
            getAllBySemesterIDAsync: getAllBySemesterIDAsync,
            getSummary: getSummary,
            insert: insert,
            update: update,
            remove: remove,
            getAllOpenForRegistration: getAllOpenForRegistration,
            registerActivityInterest: registerActivityInterest,
            getBySemesterIDAndActivityID: getBySemesterIDAndActivityID,
            getByActivityID: getByActivityID,
            getPhotoAlbum: getPhotoAlbum,
            getInfoByRange: getInfoByRange
        }
    }]);